<template>
  <div class="emission-source" ref="emissionSource">
    <div class="emission-wrap" >
      <div class="emission-sub-title">
        <input type="text" v-model="searchVal" />
        <div class="search-btn" @click="search">搜索</div>
        <div class="search-btn" @click="clear">重置</div>
      </div>
      <div class="emission-relation-list">
        <div class="emission-realtion-list-title-wrap">
          <div class="emission-relation-list-title w-20">序号</div>
          <div class="emission-relation-list-title w-80">建筑名称</div>
        </div>
        <div class="emission-relation-content" ref="srcollContainer">
          <div
            class="emission-relation-list-block"
            :class="{ 'is-outer': item.isOut }"
            @mouseover="hoverHandle(item)"
            @mouseleave="leaveHandle()"
            @click="clickHandle(item)"
            v-for="(item, key) in emissionData"
            :key="key"
          >
            <span class="w-20">{{ key + 1 }}</span>
            <span class="w-80">{{ item.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="emission-wrap" v-else v-if="customerId != 38">
      <div class="emission-relation-list">
        <div class="emission-realtion-list-title-wrap">
          <div class="emission-relation-list-title w-20">序号</div>
          <div class="emission-relation-list-title w-80">区域</div>
        </div>
        <div class="emission-relation-content" ref="srcollContainer">
          <div
            class="emission-relation-list-block"
            :class="{ 'is-outer': item.isOut }"
            @mouseover="hoverHandle(item)"
            @mouseleave="leaveHandle()"
            @click="clickArea(item)"
            v-for="(item, key) in emissionDataYG"
            :key="key"
          >
            <span class="w-20">{{ item.index + 1 }}</span>
            <span class="w-80">{{ item.name }}</span>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import mybus from "@/utils/eventbus";
import { CloseWallFunc, ShowWallDataFunc, CloseWallYGFunc, ShowWallDataYGFunc } from "@/assets/js/unity3D/index.js";
import { showWallJson } from "@/modules/EmissionSource/emissionSourceConfig/index.js";
import { wallJSON, cameraJSON, showWallJSON } from "@/views/EmissionSourceMod/ruifengEmissionSource/loadWallData.js";
import { ElMessage } from "element-plus";
export default {
  name: "EmissionSourceList",
  props: ["matrix", "x", "y"],
  data() {
    return {
      customerId: window.bmeConfig.customerSign,
      emissionData: [],
      emissionDataYG: [],
      total: 0,
      loadStr: "拼命加载中",
      searchVal: "",
      emissionSourceId: "",
    };
  },
  mounted() {
    let that = this;
    let w = $(that.$refs.emissionSource).outerWidth();
    let h = $(that.$refs.emissionSource).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    if (this.customerId != 38) {
      this.queryBuildingList();
      if (CloseWallFunc) {
        if (this.hoverTimer) {
          clearTimeout(this.hoverTimer);
        }
        CloseWallFunc();
        setTimeout(() => {
          if (CloseWallFunc) {
            CloseWallFunc();
          }
          setTimeout(() => ShowWallDataFunc(showWallJson), 50);
        }, 50);
      }
    } else { //永钢二期排放源
      this.queryBuildingList();
      if (CloseWallYGFunc) {
        if (this.hoverTimer) {
          clearTimeout(this.hoverTimer);
        }
        CloseWallYGFunc();
      }
      // this.emissionDataYG = [];
      // this.getYGemissionData();
      // this.getEmissionList();
    }
  },
  methods: {
    hoverHandle_RF(item) {
      if (this.leaveTimer) {
        clearTimeout(this.leaveTimer);
      }
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
      }
      this.hoverTimer = setTimeout(() => {
        let facilityId = item.facilityId;
        if (CloseWallFunc) {
          CloseWallFunc();
        }
        let showWallList = [];
        for (let i = 0; i < showWallJson.length; i++) {
          let tmpId = showWallJson[i]["WallID"];
          if (facilityId == tmpId) {
            let tmpObj = {
              WallID: "color_" + showWallJson[i]["WallID"],
            };
            showWallList.push(tmpObj);
          } else {
            showWallList.push(showWallJson[i]);
          }
        }
        setTimeout(() => ShowWallDataFunc(showWallList), 50);
      }, 500);
    },
    hoverHandle_YG(item) {
      if (this.leaveTimer) {
        clearTimeout(this.leaveTimer);
      }
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
      }
      this.hoverTimer = setTimeout(() => {
        let facilityId = item.facilityId;
        if (CloseWallYGFunc) {
          CloseWallYGFunc();
        }
        let showWallList = [];
        for (let i = 0; i < showWallJSON.length; i++) {
          let tmpId = showWallJSON[i]["WallID"];
          if (facilityId == tmpId) {
            let tmpObj = {
              WallID: "color_" + showWallJSON[i]["WallID"],
            };
            showWallList.push(tmpObj);
          } else {
            showWallList.push(showWallJSON[i]);
          }
        }
        console.log(showWallList, 'showWallList')
        setTimeout(() => ShowWallDataYGFunc(showWallList), 50);
      }, 500);
    },
    hoverHandle(item) {
      if(this.customerId == 42) {
        this.hoverHandle_RF(item);
      } else {
        // this.hoverHandle_YG(item);
      }
    },
    leaveHandle_RF() {
      if (this.leaveTimer) {
        clearTimeout(this.leaveTimer);
      }
      this.leaveTimer = setTimeout(() => {
        if (CloseWallFunc) {
          CloseWallFunc();
        }
        setTimeout(() => ShowWallDataFunc(showWallJson), 50);
      }, 1000);
    },
    leaveHandle_YG() {
      if (this.leaveTimer) {
        clearTimeout(this.leaveTimer);
      }
      this.leaveTimer = setTimeout(() => {
        if (CloseWallYGFunc) {
          CloseWallYGFunc();
        }
        setTimeout(() => ShowWallDataYGFunc(showWallJSON), 50);
      }, 1000);
    },
    leaveHandle() {
      if(this.customerId == 42) {
        this.leaveHandle_RF();
      } else {
        // this.leaveHandle_YG();
      }
    },
    queryBuildingList() {
      const url = CONFIG.requestName + this.$apiOpt.getBuildingList;
      const params = {
        customerId: this.customerId,
        facilityName: this.searchVal,
      };
      this.$apiUtils.get(url, params).then((res) => {
        this.emissionData = res;
      });
    },
    search() {
      this.emissionData = [];
      this.queryBuildingList();
    },
    clear() {
      this.searchVal = "";
      this.emissionData = [];
      this.queryBuildingList();
    },
    clickHandle(item) {
      mybus.$emit("buildclick", item.facilityId);
    },
  },
};
</script>

<style lang="scss" scoped>
.emission-source {
  height: 900px;
  width: 620px;
}
.emission-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  // background: url('./img/list_bg.png');
  padding: 40px 30px 20px 30px;
}

.emission-title {
  width: 52%;
  margin: 0 auto;
  font-size: 20px;
  color: #f4c48f;
  font-weight: bold;
  height: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-bottom: 2px solid #4a90e2;
  margin-bottom: 15px;
}

.emission-sub-title {
  height: 5%;
  display: flex;
  align-items: center;
  justify-content: center;

  color: #fff;
  margin-bottom: 15px;
}

.emission-relation-list-title {
  display: flex;
  align-items: center;
  justify-content: center;
}

.emission-relation-list {
  background-color: rgba(0, 0, 0, 0.2);
  width: 100%;
  height: 80%;
}

.emission-relation-content {
  width: 98%;
  height: 90%;
  overflow-y: scroll;
}

.emission-relation-list-block {
  width: 100%;
  height: 15%;
  text-align: center;
  border-bottom: 2px solid #4a90e2;
  border-image: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.1),
      #4a90e2,
      rgba(0, 0, 0, 0.1)
    )
    1 1;
  text-align: center;
  color: #fff;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-image: radial-gradient(
    rgba(0, 0, 0, 0.8),
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0.1)
  );
}

.is-outer {
  background-image: radial-gradient(
    rgba(0, 0, 0, 0.8),
    rgba(235, 216, 50, 0.5),
    rgba(0, 0, 0, 0.1)
  );
}

.emission-relation-list-block:hover {
  background: url("./img/detail_bg_title_hover.png");
  background-size: 100% 100%;
}

.pt-15 {
  padding-top: 13%;
}

.pt-0 {
  padding-top: 0;
}

/*滚动条样式*/
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 4px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #4a90e2;
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 0;
}

.w-20 {
  width: 20%;
  border-right: 2px solid #4a90e2;
}

.w-80 {
  width: 80%;
}

.emission-realtion-list-title-wrap {
  height: 10%;
  width: 100%;
  display: flex;
  background: url("./img/list_title_bg.png");
  background-size: 100% 100%;
  text-align: center;
  font-size: 18px;
  color: #fff;
}

.emission-sub-title input {
  width: 50%;
  height: 100%;
  background-color: rgba(2, 20, 41, 0.2);
  outline: none;
  border: 1px solid #333;
  text-indent: 20px;
  font-size: 18px;
  color: #fff;
  border-radius: 4px;
  padding: 0;
}

.emission-sub-title input:focus {
  border: 1px solid #4a90e2;
}

.search-btn {
  width: 20%;
  font-size: 18px;
  height: 100%;
  background-color: rgba(2, 20, 41, 0.1);
  border: 1px solid #333;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 10px;
}
.emissionList {
  position: absolute;
  width: 1000px;
  height: 600px;
  left: -1200px;
  top: 0;
  background-color: rgba(1, 21, 43, 0.75);
  .el-table {
    .el-table__row {
      background: transparent !important;
      tr, tr td {
        background: transparent !important;
      }
    }
  }
}
</style>
